import { Mesh } from "three";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import model from "../../../../../assets/models/team2/SubTopic3/tooltipCafe.glb";
import { GUI } from "dat.gui";
import { gsap } from "gsap";
import ObserverEmitter, { EVENTS } from "../../../../../emitter/Observer";

export class TooltipLimpiezaOne extends Mesh {
	constructor(camera, loadingManager) {
		super();
		let loader = new GLTFLoader(loadingManager);
		let dracoloader = new DRACOLoader();
		this.camera = camera;
		dracoloader.setDecoderPath("https://www.gstatic.com/draco/versioned/decoders/1.5.5/");
		this.loading = loader;
		loader.setDRACOLoader(dracoloader);
		this.onLoadModel(loader);
		this.scale.set(1, 1, 1);
		this.observerListtneners();
		// this.helpers();
	}

	onLoadModel(loader) {
		loader.load(model, (gltf) => {
			// gltf.scene.visible = false;
			this.add(gltf.scene);
			this.azucar = gltf.scene.getObjectByName("azucar", true);
			this.splenda = gltf.scene.getObjectByName("splenda", true);
			this.vaso4 = gltf.scene.getObjectByName("vaso4", true);
			this.vaso12 = gltf.scene.getObjectByName("vaso12", true);
			this.vaso16 = gltf.scene.getObjectByName("vaso16", true);
		});
	}

	onvisibleObjects() {
		this.azucar.visible = false;
		this.splenda.visible = false;
		this.vaso4.visible = false;
		this.vaso12.visible = false;
		this.vaso16.visible = false;
		// this.helpersChild();
	}

	onEliminateScene() {
		if (this.animation) {
			this.animation.kill();
		}
		this.visible = false;
	}

	observerListtneners() {
		ObserverEmitter.on(EVENTS.team2.subtopicThree.activityThree.limpiezaKobalto.stepTooltipOne.azucar, () => {
			this.azucar.position.set(-0.4118, 0, 0.4704);
			this.azucar.visible = true;
		});
		ObserverEmitter.on(EVENTS.team2.subtopicThree.activityThree.limpiezaKobalto.stepTooltipOne.splenda, () => {
			this.azucar.visible = false;
			this.splenda.position.set(0.4704, 0, 0.4704);
			this.splenda.rotation.y = -0.5441;
			this.splenda.visible = true;
		});
		ObserverEmitter.on(EVENTS.team2.subtopicThree.activityThree.limpiezaKobalto.stepTooltipOne.vaso4, () => {
			this.splenda.visible = false;
			this.vaso4.position.set(0.4704, -0.0847, 0.4704);
			this.vaso4.visible = true;
		});
		ObserverEmitter.on(EVENTS.team2.subtopicThree.activityThree.limpiezaKobalto.stepTooltipOne.vaso12, () => {
			this.vaso4.visible = false;
			this.vaso12.position.set(0.4704, -0.3659, 0.4704);
			this.vaso12.visible = true;
		});
		ObserverEmitter.on(EVENTS.team2.subtopicThree.activityThree.limpiezaKobalto.stepTooltipOne.vaso16, () => {
			this.vaso12.visible = false;
			this.vaso16.position.set(0.1633, -0.8529, 0.4704);
			this.vaso16.visible = true;
		});
	}

	onAnimate(object, previousObject) {
		if (this.animation) {
			this.animation.kill();
		}

		//*regresar el color al anterior
		this.beforeColor = object.material.emissive;
		if (previousObject !== undefined) {
			if (this[previousObject] !== undefined) {
				this[previousObject].material.emissive = this.beforeColor;
			}
		}

		const newMaterial = object.material.clone();
		object.material = newMaterial;

		object.material.emissive.set("#404040");

		this.animation = gsap.to(object.material, {
			emissiveIntensity: 25,
			yoyo: true,
			repeat: -1,
			duration: 0.8,
			ease: "power1.inOut",
		});
	}

	helpers() {
		const gui = new GUI();
		const premiaFolder = gui.addFolder("Tooltip");
		premiaFolder.add(this.position, "x", -20, 20).step(0.0001).name("Posición X");
		premiaFolder.add(this.position, "y", -20, 20).step(0.0001).name("Posición Y");
		premiaFolder.add(this.position, "z", -20, 20).step(0.0001).name("Posición Z");
		premiaFolder.add(this.rotation, "x", -5, 5).step(0.0001).name("rotation X");
		premiaFolder.add(this.rotation, "y", -5, 5).step(0.0001).name("rotation Y");
		premiaFolder.add(this.rotation, "z", -5, 5).step(0.0001).name("rotation Z");
	}

	helpersChild() {
		this.helperMethod("azucar", this.azucar);
	}

	helperMethod(name, object) {
		const { position, rotation } = object;
		const gui = new GUI();
		const folferMostrador = gui.addFolder(name);
		folferMostrador.add(position, "x", -20, 20).step(0.0001).name("Posición X");
		folferMostrador.add(position, "y", -20, 20).step(0.0001).name("Posición Y");
		folferMostrador.add(position, "z", -20, 20).step(0.0001).name("Posición Z");
		folferMostrador.add(rotation, "x", -5, 5).step(0.0001).name("rotation X");
		folferMostrador.add(rotation, "y", -5, 5).step(0.0001).name("rotation Y");
		folferMostrador.add(rotation, "z", -5, 5).step(0.0001).name("rotation Z");
		folferMostrador.add(object, "visible").name("Visible");
	}

	renderAnimations() { }
}
